import { Cell, ReactGrid } from "@silevis/reactgrid"
import _, { isNull, isUndefined } from "lodash";
import { NonEditableCell } from "@components/reactgrid/cellTemplate/NonEditableCell";

const BaseGrid: React.FC<{ columnsDesc: any, data: any, style: React.CSSProperties, onEdit: (id: any, key: any, newValue: any) => void }> = ({ columnsDesc, data, style, onEdit }) => {
    const columns = columnsDesc.map((col: any, idx: number) => {
        return {
            ...col,
            colIndex: idx,
        }
    })

    const rows: Cell[] = data.reduce((acc: Cell[], row: any, rowNum: number) => {
        return [
            ...acc,
            ...columns.map((col: any) => {
                // console.log(col.key, _.get(row, col.key))
                return {
                    rowIndex: rowNum + 1,
                    colIndex: col.colIndex,
                    Template: NonEditableCell,
                    props: {
                        text: isNull(_.get(row, col.key)) || isUndefined(_.get(row, col.key)) ? '' : String(_.get(row, col.key)),
                        style: col.style,
                        // text: row[col.key],
                        onTextChanged: (newText: any) => {
                            console.log(newText)
                        },
                    }
                }
            }),
        ]
    }, [])

    const cells: Cell[] = [
        ...columns.map((col: any, idx: number) => {
            return {
                rowIndex: 0,
                colIndex: idx,
                Template: NonEditableCell,
                props: {
                    style: {
                        fontWeight: 500,
                        borderBottom: `2px solid ${col.marker}`,
                    },
                    text: col.title,
                }
            }
        }),
        ...rows,
    ];

    return (
        <div className='scrollbox' style={{
            overflow: 'hidden',
            ...style,
        }}>
            <div className='scrollbox-inner' style={{
                overflowX: 'auto',
                overflowY: 'auto',
                ...style,
            }}>
                <ReactGrid
                    stickyTopRows={1}
                    columns={columns}
                    cells={cells}
                    enableColumnSelectionOnFirstRow
                />
            </div>
        </div>
    )
};

export default BaseGrid